import React, { useEffect, useState } from "react";
import Header from "../../layout/Header";
import Sidebar from "../../layout/Sidebar";
import $ from "jquery";
import { Select, Button, Table, DatePicker } from "antd";
import "./reports.css";
import * as XLSX from "xlsx";
import Bridge from "../../constants/Bridge";
import { DownloadOutlined } from "@ant-design/icons";

const { RangePicker } = DatePicker;

const Reports = () => {
  useEffect(() => {
    if ($(window).width() < 600) {
      $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
    } else {
      $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
    }
    fetchDashboardData();
  }, []);

  const [tableData, setTableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [siteOptions, setSiteOptions] = useState([]);
  const [selectedSites, setSelectedSites] = useState([]);
  const [selectedParticipantIds, setSelectedParticipantIds] = useState([]);
  const [participantIdOptions, setParticipantIdOptions] = useState([]);
  const [siteToParticipantIds, setSiteToParticipantIds] = useState({});
  const [filteredParticipantIdOptions, setFilteredParticipantIdOptions] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [sessionOptions, setSessionOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState([]);

  const { Option } = Select;

  const downloadCSV = () => {
    const dataToExport = (selectedSites.length > 0 || selectedParticipantIds.length > 0 || selectedSession || dateRange.length > 0)
      ? filteredData
      : tableData;

    const csvData = dataToExport.map(item => ({
      site: item.site,
      participant_id: item.participant_id,
      last_visit: item.last_session && item.last_visit.props
        ? `${item.last_session} (${item.last_visit.props.children[1].props.children})`
        : '-',
      next_visit: item.next_session && item.next_visit.props
        ? `${item.next_session} (${item.next_visit.props.children[1].props.children})`
        : '-',
      average_fvc: item.average_fvc,
      average_svc: item.average_svc
    }));

    const worksheet = XLSX.utils.json_to_sheet(csvData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reports");
    XLSX.writeFile(workbook, "reports_data.csv");
  };

  const fetchDashboardData = async () => {
    setLoading(true);
    const result = await Bridge.myStudies.getReportsData();

    let uniqueSites = new Set();
    let uniqueParticipantIds = new Set();
    let uniqueSessions = new Set();
    let siteToParticipantIdsMap = {};

    if (result && result.data && result.data.length > 0) {
      const tableData = result.data
        .map(item => {
          const site = String(item.site || "").trim();
          const participantId = String(item.rapa_id || "").trim();

          if (site && site !== "-" && site !== "--") {
            uniqueSites.add(site);

            if (!siteToParticipantIdsMap[site]) {
              siteToParticipantIdsMap[site] = new Set();
            }
            if (participantId && participantId !== "-") {
              siteToParticipantIdsMap[site].add(participantId);
            }
          }

          if (participantId && participantId !== "-") {
            uniqueParticipantIds.add(participantId);
          }

          if (item.lastSession && item.lastSession !== "-") {
            uniqueSessions.add(item.lastSession);
          }
          if (item.nextSession && item.nextSession !== "-") {
            uniqueSessions.add(item.nextSession);
          }

          return {
            key: item.participants_id,
            site: site == "" ? "-" : site,
            participant_id: participantId,
            last_visit: (
              <>
                <span>{item.lastSession == "" ? "-" : item.lastSession}</span>
                <span>{item.lastSessionDate == "" ? "-" : item.lastSessionDate}</span>
              </>
            ),
            next_visit: (
              <>
                <span>{item.nextSession == "" ? "-" : item.nextSession}</span>
                <span>{item.nextSessionDate == "" ? "-" : item.nextSessionDate}</span>
              </>
            ),
            last_session: item.lastSession,
            next_session: item.nextSession,
            lastSessionDate: item.lastSessionDate,
            nextSessionDate: item.nextSessionDate,
            average_fvc: (() => {
              const val = parseFloat(item.averageFVC);
              return !isNaN(val) && val > 0 ? val.toFixed(2) : "0.00";
            })(),
            average_svc: (() => {
              const val = parseFloat(item.averageSVC);
              return !isNaN(val) && val > 0 ? val.toFixed(2) : "0.00";
            })(),
          };
        })
        .filter(item => {
          const lastVisitText = typeof item.last_visit === "string" ? item.last_visit : "";
          const nextVisitText = typeof item.next_visit === "string" ? item.next_visit : "";

          return !(
            (!item.site || item.site === "-" || item.site === "--") &&
            (!item.participant_id || item.participant_id === "-" || item.participant_id === "--") &&
            (!lastVisitText || lastVisitText === "-" || lastVisitText === "--") &&
            (!nextVisitText || nextVisitText === "-" || nextVisitText === "--") &&
            (!item.average_fvc || item.average_fvc === "-" || item.average_fvc === "--") &&
            (!item.average_svc || item.average_svc === "-" || item.average_svc === "--")
          );
        });

      Object.keys(siteToParticipantIdsMap).forEach(site => {
        siteToParticipantIdsMap[site] = Array.from(siteToParticipantIdsMap[site]);
      });

      setTableData(tableData);
      setSiteToParticipantIds(siteToParticipantIdsMap);
      setSiteOptions([...uniqueSites]);
      setParticipantIdOptions([...uniqueParticipantIds]);
      setSessionOptions([...uniqueSessions]);
    }
    setLoading(false);
  };

  const handleParticipantIdFilter = (selectedIds) => {
    setSelectedParticipantIds(selectedIds);
    applyFilters(selectedSites, selectedIds, selectedSession, dateRange);
  };

  const handleSiteFilterChange = (selectedValues) => {
    setSelectedSites(selectedValues);

    let filteredIds = [];
    if (selectedValues?.length) {
      filteredIds = selectedValues.flatMap(site => siteToParticipantIds[site] || []);
      filteredIds = [...new Set(filteredIds)];
      setFilteredParticipantIdOptions(filteredIds);
    } else {
      setFilteredParticipantIdOptions(participantIdOptions);
    }

    applyFilters(selectedValues, selectedParticipantIds, selectedSession, dateRange);
  };

  // const handleSessionFilter = (selectedSession) => {
  //   setSelectedSession(selectedSession);

  //   if (!selectedSession) {
  //     applyFilters(selectedSites, selectedParticipantIds, null, dateRange);
  //     return;
  //   }

  //   const sessionPrefixMatch = selectedSession.match(/C\d+D\d+/);
  //   const sessionPrefix = sessionPrefixMatch ? sessionPrefixMatch[0] : selectedSession;

  //   applyFilters(selectedSites, selectedParticipantIds, sessionPrefix, dateRange);
  // };

  // const handleDateRangeChange = (dates) => {
  //   const safeDates = dates || [];
  //   setDateRange(safeDates);
  //   applyFilters(selectedSites, selectedParticipantIds, selectedSession, safeDates);
  // };

  // const applyFilters = (sites, participantIds, sessionPrefix, dateRange) => {
  //   let filtered = [...tableData];
  
  //   // Filter by sites
  //   if (sites && sites.length > 0) {
  //     filtered = filtered.filter(item => sites.includes(item.site));
  //   }
  
  //   // Filter by participant IDs
  //   if (participantIds && participantIds.length > 0) {
  //     filtered = filtered.filter(item => participantIds.includes(item.participant_id));
  //   }
  
  //   // Filter by session prefix
  //   if (sessionPrefix) {
  //     filtered = filtered.filter(item =>
  //       (item.last_session && item.last_session.includes(sessionPrefix)) ||
  //       (item.next_session && item.next_session.includes(sessionPrefix))
  //     );
  //   }
  
  //   // Filter by date range
  //   if (Array.isArray(dateRange) && dateRange.length === 2) {
  //     const [startDate, endDate] = dateRange.map(date => new Date(date).setHours(0, 0, 0, 0)); // Normalize dates
  //     filtered = filtered.filter(item => {
  //       const lastVisitDate = item.lastSessionDate ? new Date(item.lastSessionDate).setHours(0, 0, 0, 0) : null;
  //       const nextVisitDate = item.nextSessionDate ? new Date(item.nextSessionDate).setHours(0, 0, 0, 0) : null;
  
  //       // Include rows where either lastVisitDate or nextVisitDate falls within the range
  //       return (
  //         (lastVisitDate && lastVisitDate >= startDate && lastVisitDate <= endDate) ||
  //         (nextVisitDate && nextVisitDate >= startDate && nextVisitDate <= endDate)
  //       );
  //     });
  //   }
  
  //   // Update the filtered data
  //   setFilteredData(filtered);
  // };
  const applyFilters = (sites, participantIds, sessionPrefix, dateRange) => {
    let filtered = [...tableData];
  
    // Apply all filters in sequence
    if (sites && sites.length > 0) {
      filtered = filtered.filter(item => sites.includes(item.site));
    }
  
    if (participantIds && participantIds.length > 0) {
      filtered = filtered.filter(item => participantIds.includes(item.participant_id));
    }
  
    if (sessionPrefix) {
      const sessionPrefixMatch = sessionPrefix.match(/C\d+D\d+/);
      const prefixToMatch = sessionPrefixMatch ? sessionPrefixMatch[0] : sessionPrefix;
      
      filtered = filtered.filter(item =>
        (item.last_session && item.last_session.includes(prefixToMatch)) ||
        (item.next_session && item.next_session.includes(prefixToMatch))
      );
    }
  
    if (Array.isArray(dateRange) && dateRange.length === 2) {
      const [startDate, endDate] = dateRange.map(date => 
        date ? new Date(date).setHours(0, 0, 0, 0) : null
      ).filter(date => date !== null);
  
      if (startDate && endDate) {
        filtered = filtered.filter(item => {
          const lastVisitDate = item.lastSessionDate ? 
            new Date(item.lastSessionDate).setHours(0, 0, 0, 0) : null;
          const nextVisitDate = item.nextSessionDate ? 
            new Date(item.nextSessionDate).setHours(0, 0, 0, 0) : null;
  
          return (
            (lastVisitDate && lastVisitDate >= startDate && lastVisitDate <= endDate) ||
            (nextVisitDate && nextVisitDate >= startDate && nextVisitDate <= endDate)
          );
        });
      }
    }
  
    setFilteredData(filtered);
  };
  
  // Update the handleSessionFilter to properly extract session prefix
  const handleSessionFilter = (selectedSession) => {
    setSelectedSession(selectedSession);
    applyFilters(selectedSites, selectedParticipantIds, selectedSession, dateRange);
  };
  
  // Update the date range handler to maintain other filters
  const handleDateRangeChange = (dates) => {
    const safeDates = dates || [];
    setDateRange(safeDates);
    applyFilters(selectedSites, selectedParticipantIds, selectedSession, safeDates);
  };
  const columns = [
    {
      title: "Site",
      dataIndex: "site",
      key: "name",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Participant Id",
      dataIndex: "participant_id",
      key: "participant_id",
    },
    {
      title: "Last Visit",
      dataIndex: "last_visit",
      key: "last_visit",
      width: 175,
      render: (text, record) => (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>{record.last_session || '-'}</span>
          <span>{record.lastSessionDate || '-'}</span>
        </div>
      ),
    },
    {
      title: "Next Visit",
      dataIndex: "next_visit",
      key: "next_visit",
      width: 150,
      render: (text, record) => (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>{record.next_session || '-'}</span>
          <span>{record.nextSessionDate || '-'}</span>
        </div>
      ),
    },
    {
      title: "Average FVC",
      dataIndex: "average_fvc",
      key: "average_fvc",
    }, {
      title: "Average SVC",
      dataIndex: "average_svc",
      key: "average_svc",
    },
  ];
const sessions=[
  "Base line 1",
  "Base line 2",
  "Base line 3",
  "C1D1 24 Hr Post Session",
  "C2D1 24 Hr Post Session",
  "C3D1 24 Hr Post Session",
  "C4D1 24 Hr Post Session",
  "Biweekly Session ",
  "250 Day Visit Post Session ",
  "Expanded Monitoring Biweekly Session ",
];
  return (
    <div className="participant-activity-div radcliff-participant-page">
      <Header />
      <div className="row">
        <Sidebar />
        <div className="col-lg-10 participant-right-section-wrapper">
          <div className="row">
            <div className="inner-wrapper">
              <div className="row top-space">
                <div className="col-lg-1"></div>
                <div className="col-lg-11">
                  <div className="ambassador-heading-section mb-3">
                    <h3
                      style={{
                        position: "relative",
                        fontSize: 28,
                        fontFamily: "Open Sans",
                        fontWeight: "bold",
                        color: "#1A4F83",
                        textAlign: "start",
                        marginLeft: "10px",
                      }}
                      className="mb-3"
                    >
                      Reports
                    </h3>
                  </div>
                </div>
              </div>
              <div className="content">
                <div style={{ width: "100%" }}>
                  <div className="row align-items-center justify-content-around">
                    <div className="col-lg-1"></div>
                    <div className="col-lg-2 filter-by-activity-input-wrapper">
                      <div className=" mt-1 filter-by-activity-input">
                        <label className="filter-label" style={{ fontSize: '12px' }}>
                          Filter By Site
                        </label>
                        <Select
                          mode="multiple"
                          showSearch
                          allowClear
                          style={{ width: 150 }}
                          placeholder="Select Site"
                          optionFilterProp="children"
                          maxTagCount={3}
                          labelInValue={false}
                          value={selectedSites}
                          onChange={handleSiteFilterChange}
                        >
                          {siteOptions.map(site => (
                            <Option key={site} value={site}>
                              {site}
                            </Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <div className="mt-3 col-12 col-sm-10 col-lg-2 filter-by-independant-coach-input">
                      <label style={{ fontSize: '12px' }}>Filter By Participant ID</label>
                      <Select
                        mode="multiple"
                        showSearch
                        placeholder="Select ID"
                        allowClear
                        style={{ width: "100%" }}
                        className="filter-element mb-2 filter-select-menu"
                        onChange={handleParticipantIdFilter}
                        value={selectedParticipantIds}
                        maxTagCount={3}
                      >
                        {(selectedSites.length > 0 ? filteredParticipantIdOptions : participantIdOptions).map(id => (
                          <Option key={id} value={id}>
                            {id}
                          </Option>
                        ))}
                      </Select>
                    </div>
                    <div className="col-12 col-sm-10 col-lg-2 filter-by-column-input-wrapper">
                      <label style={{ fontSize: '12px' }}>Filter By Session</label>
                      <Select
                        showSearch
                        placeholder="Select session"
                        allowClear
                        style={{ width: "100%" }}
                        className="filter-element filter-status-select"
                        dropdownStyle={{ textAlign: 'left' }}
                        onChange={handleSessionFilter}
                        value={selectedSession}
                      >
                        {sessions.map(session => (
                          <Option key={session} value={session}>
                            {session}
                          </Option>
                        ))}
                      </Select>
                    </div>
                    <div className="col-12 col-sm-10 col-lg-2 filter-by-column-input-wrapper">
                      <label style={{ fontSize: '12px',marginTop:15 }}>Filter by Time Interval</label>
                      <RangePicker
                        style={{ width: "100%",height: 55 }}
                        onChange={handleDateRangeChange}
                      />
                    </div>
                    <div className="mt-4 col-12 col-sm-10 col-lg-2 filter-by-column-input-wrapper align-items-center">
                      <Button type="primary" icon={<DownloadOutlined />} style={{ height: 40 }} onClick={downloadCSV}>Generate Report</Button>
                    </div>
                  </div>
                  <div className="row participant-activity-table">
                    <div
                      className="col-lg-11 mt-3"
                      style={{ marginLeft: "auto" }}
                    >
                      <Table
                        columns={columns}
                        loading={loading}
                        dataSource={
                          (selectedSites.length > 0 ||
                            selectedParticipantIds.length > 0 ||
                            selectedSession ||
                            dateRange.length > 0)
                            ? filteredData
                            : tableData
                        }
                        rowKey="key"
                        pagination={true}
                        rowClassName={() => "custom-row-height"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reports;
